import script from "./ProductListPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductListPopover.vue?vue&type=script&setup=true&lang=js"

import "./ProductListPopover.vue?vue&type=style&index=0&id=6442c3d5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Murilo\\Documents\\app-construp-cms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6442c3d5"]])

export default __exports__